import React from "react";
import style from "./index.module.scss";
import MainLayout from "components/Layouts/MainLayout";
import { Breadcrumb, Spin } from "antd";
import { RouteComponentProps, useHistory } from "react-router-dom";
import useDeviceType from "Utils/useDeviceType";
import useRequest from "Utils/useRequest";
import { getVotePaperInfo } from "API/vote";
import { toNumber } from "Utils/filter";
import VoteHeader from "./components/VoteHeader";
import VoteForm from "./components/VoteForm";
import CourseError from "../components/CourseError";

interface VoteDetailProps {
    id: string;
}

export default function VoteDetail({
    match
}: RouteComponentProps<VoteDetailProps>) {
    const id = toNumber(match.params.id);
    const history = useHistory();
    const { isPC } = useDeviceType();
    const [data, { loading, error }, refreshData] = useRequest(() =>
        getVotePaperInfo(id)
    );

    const breadcrumb = (
        <Breadcrumb separator=">">
            <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
            <Breadcrumb.Item onClick={history.goBack}>课程内容</Breadcrumb.Item>
            <Breadcrumb.Item>提交投票</Breadcrumb.Item>
        </Breadcrumb>
    );

    if (error) return <CourseError breadcrumb={breadcrumb} />;

    return (
        <MainLayout className={style.root} title="提交投票">
            {isPC && breadcrumb}

            <div className={style.body}>
                <Spin spinning={loading}>
                    <VoteHeader data={data} />
                    <VoteForm data={data} onSuccess={history.goBack} />
                </Spin>
            </div>
        </MainLayout>
    );
}
